// In-app notifications (the bell) and push: each notification type belongs to
// one topic, and each person can turn push off per topic in Settings. The
// bell always shows everything.

export const NOTIFICATION_TOPICS = ['orders', 'messages', 'social', 'guilds', 'riders'] as const;
export type NotificationTopic = (typeof NOTIFICATION_TOPICS)[number];

export const TOPIC_LABELS: Record<NotificationTopic, { label: string; description: string; title: string }> = {
  orders: { label: 'Orders and refunds', description: 'New orders, status changes, refunds owed and reports.', title: 'Order update' },
  messages: { label: 'Messages', description: 'Direct messages to you.', title: 'New message' },
  social: { label: 'Likes, comments and follows', description: 'Activity on your posts and new followers.', title: 'Guildite' },
  guilds: { label: 'Guilds', description: 'Seller requests, approvals and group buys.', title: 'Guild activity' },
  riders: { label: 'Rider jobs', description: 'Delivery offers and job updates for riders.', title: 'Rider job' },
};

// The notification `type` field the Worker writes → its topic.
export function topicForType(type: unknown): NotificationTopic {
  switch (type) {
    case 'message': return 'messages';
    case 'like': case 'comment': case 'follow': return 'social';
    case 'guild': return 'guilds';
    case 'rider': return 'riders';
    default: return 'orders';
  }
}

export type TopicSettings = Record<NotificationTopic, boolean>;

// Everything is on until the person turns it off.
export function readTopicSettings(value: unknown): TopicSettings {
  const record = (value && typeof value === 'object' ? value : {}) as Record<string, unknown>;
  return Object.fromEntries(NOTIFICATION_TOPICS.map(topic => [topic, record[topic] !== false])) as TopicSettings;
}
